export const MAIN_CLASS = 'ib-register-page';

export const INPUT_LABEL_CLASS = `${MAIN_CLASS}__input-label`;

export const BUTTON_CLASS = `${MAIN_CLASS}__button`;

export const INPUT_MAX_LENGTH = 64;
